<div class="buttons-container">
  <div
    class="button mimics"
    data-cy="vessel-folder-mimic-editor-button"
    [ngStyle]="{ cursor: buttonsAreDisabled ? 'not-allowed' : 'pointer' }"
    (click)="openEditorPage()">
    <mat-icon svgIcon="vessel-page-mimics" class="icon" />
    {{ 'vessel.page.button.mimics' | translate }}
  </div>

  <div
    class="button"
    data-cy="vessel-folder-channels-button"
    [ngStyle]="{ cursor: buttonsAreDisabled ? 'not-allowed' : 'pointer' }"
    (click)="openChannelsPage()">
    <mat-icon svgIcon="vessel-page-excel" class="icon" />
    {{ 'vessel.page.button.channels' | translate }}
  </div>

  <div
    class="button"
    data-cy="vessel-folder-ops-settings-button"
    [ngStyle]="{ cursor: buttonsAreDisabled ? 'not-allowed' : 'pointer' }"
    (click)="openOpsSetting()">
    <mat-icon svgIcon="vessel-page-nexus" class="icon" />
    {{ 'vessel.page.button.system-settings' | translate }}
  </div>

  <div
    class="button"
    data-cy="vessel-folder-system-spec-button"
    [ngStyle]="{ cursor: buttonsAreDisabled ? 'not-allowed' : 'pointer' }"
    (click)="openSpecificationPage()">
    <mat-icon svgIcon="vessel-page-spec" class="icon" />
    {{ 'vessel.page.button.system-spec' | translate }}
  </div>

  <div
    class="button"
    data-cy="vessel-folder-print-button"
    [ngStyle]="{ cursor: buttonsAreDisabled ? 'not-allowed' : 'pointer' }"
    (click)="openMainPrintDialog()">
    <mat-icon svgIcon="vessel-page-print" class="icon" />
    {{ 'vessel.page.button.print' | translate }}
  </div>

  <div
    data-cy="vessel-folder-vessel-data-menu-button"
    class="button"
    [ngStyle]="{ cursor: buttonsAreDisabled ? 'not-allowed' : 'pointer' }"
    [class.darkBorder]="showVesselDataOption"
    (click)="$event.stopPropagation(); showVesselDataOption = !showVesselDataOption">
    <mat-icon svgIcon="vessel-page-data" class="icon" />
    <div class="icon-text-row">
      {{ 'vessel.page.button.vessel-data' | translate }}
      <mat-icon
        svgIcon="breadcrumb-chevron"
        class="chevron-icon"
        [class.rotateIcon]="showVesselDataOption" />
    </div>
    <ng-container *ngIf="showVesselDataOption">
      <div class="vessel-data-options-container">
        <div class="vessel-data-row" data-cy="vessel-folder-import-data-button">
          <mat-icon svgIcon="import" class="small-icon" />
          <div>
            {{ 'vessel.page.button.import-data' | translate }}
          </div>
        </div>
        <div
          class="vessel-data-row"
          data-cy="vessel-folder-download-data-button"
          (click)="downloadData()">
          <mat-icon svgIcon="download" class="small-icon" />
          <div>
            {{ 'vessel.page.button.download-data' | translate }}
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
